import React, { useEffect } from "react";
import "./Program_Details.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import {
  faCalendarDays,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPrograms, SingleEvent } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";
import { decodeId, encodeId, formatDate, formatTime } from "../../utils/common";

const Program_Details = () => {
  const navigate = useNavigate()


  const dispatch = useDispatch();
  const id = useParams()

  const event = useSelector((state) => state.common.event);
  const eventPrograms = useSelector((state) => state.common.all_event_programs);


  useEffect(() => {
    if (id)
      dispatch(SingleEvent({ id: decodeId(id?.id) }));
    dispatch(EventPrograms({ id: decodeId(id?.id) }));
  }, [dispatch]);

  const breadcrumbs = [
    { label: "EXPLORE", link: "/EXPLORE", active: false },
    { label: "NEAR BY EVENTS", link: "/near-by-events", active: false },
    { label: event?.name, link: "", active: true },
  ];

  return (
    <section className="Program_Details">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />

        <div className="main_content_div">
          <div className="program_img_div">
            <img
              src={IDS.IMG_URL + event?.Event?.image}
              // src="/assets/images/event_registration/inner_near_by_events/program.png"
              className="program_img"
            />
          </div>

          <div className="content_div">
            <div className="share_icon_div">
              <FontAwesomeIcon icon={faShareNodes} className="share_icon" />
            </div>

            <div className="top_div">
              <p className="title_text">
                {event?.name || ""}, {[event?.Event?.State?.name, event?.Event?.Country?.name,].filter(Boolean).join(", ")}
                {/* Environment Day Awareness, Ankleshwar, India */}
              </p>
              <p className="date_text">
                <FontAwesomeIcon icon={faCalendarDays} className="date_icon" />
                {/* AUG 2025, 12:00 pm */}

                {formatDate(event.Event?.start_date, true).toLocaleUpperCase()}, {formatTime(event?.Event?.start_time) || ""}
              </p>
            </div>

            {/* <div className="label_value_div">
              <div className="top_value_div">
                <p className="label_text">Lanaguge</p>
              </div>
              <p className="value_text">Tamil </p>
            </div> */}

            {/* <div className="label_value_div">
              <div className="top_value_div">
                <p className="label_text">Lanaguge</p>
                <p className="link_text">View Location</p>
              </div>

              <p className="value_text">Tamil </p>
            </div> */}

            <div className="label_value_div">
              <div className="top_value_div">
                <p className="label_text">Program Fees</p>
              </div>

              <p className="value_text">₹ {event?.Event?.price || ""}</p>
            </div>

            <div className="register_div">
              <Orange_Btn btnText={"Register Now"} onClick={() => { navigate(`/personal-info-form/${encodeId(event?.event_id)}`) }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program_Details;
